import { render } from "./rectorStudioHome.vue?vue&type=template&id=3b0d032c&scoped=true"
import script from "./rectorStudioHome.vue?vue&type=script&lang=js"
export * from "./rectorStudioHome.vue?vue&type=script&lang=js"

import "./rectorStudioHome.vue?vue&type=style&index=0&id=3b0d032c&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0d032c"]])

export default __exports__